import axios from 'axios'
import ElementUI from 'element-ui'; //引入element组件库
import router from '@/router';
import AES from "../utils/AES.js";
import store from '../store'
import md5 from "js-md5"
import Utils from './utils.js'

const isDev = false; // 是否是开发环境，在这设置为了方便能测试正式环境的接口

const request = axios.create({
    baseURL: isDev ? 'https://test-wankang.xlhcq.com' : 'https://wankang.xlhcq.com',
    timeout: 99999 // 请求超时时间
})
let data = {
    version: "1.0.0",
    client: 3,
    user_id: "",
    channel: "web",
    mac: "",
    imei: "",
    oaid: "",
    android_id: "",
    timestamp: Math.floor(Date.now() / 1000),
    device: "",
    bd_vid: null,
    model: null
}
request.interceptors.request.use(config => {
    data.model = Utils.getBrowserName();
    data.device = md5(navigator.userAgent);
    if (sessionStorage.getItem("bd_vid")) {
        data.bd_vid = AES.dedata(sessionStorage.getItem("bd_vid"));
    }
    // 以 json 方式提交 
    config.headers['Content-Type'] = 'application/json';
    if (localStorage.getItem("token")) {
        config.headers['Access-Token'] = AES.dedata(localStorage.getItem("token"));
    }
    if (isDev) {
        config.headers["cp"] = JSON.stringify(data);
    } else { // 正式环境
        config.headers["cp"] = AES.encrypt(JSON.stringify(data), store.state.secretKey);
        if (config.data) {
            config.data = {
                data: AES.encrypt(JSON.stringify(config.data), store.state.secretKey)
            };
        }
    }
    config.headers["xos"] = 5;
    return config;
})
request.interceptors.response.use(
    response => {
        if (response) { 
            return response.data;
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        if (error.response.status) {
            ElementUI.Message({
                message: error.message,
                type: 'error'
            })
            return Promise.reject(error.response);
        } else {
        }
    }
)
// 获取浏览器信息
export default request // 导出自定义创建 axios 对象